<template>
  <div style="display: flex; flex-direction: column">
    <div class="toolbar">
      <div class="search" />
      <div />
    </div>
    <div style="display: flex; flex: auto">
      <div v-div-height-fix style="width: 15%">
        <el-tree-ex
          ref="tree"
          url="SystemApplication/ProcedureStep/ProcedureStepEntry"
          :props="{ children: 'entrys', label: 'fName' }"
          node-key="fName"
          :deal-return-data="handleTreeData"
          :is-dispaly="false"
          @node-click="handleNodeClick"
          @node-modify="handleNodeModify"
          @node-delete="handleNodeDelete"
        />
      </div>
      <div style="width: 85%; display: flex; flex-direction: column">
        <el-table
          v-loading="loading"
          v-el-table-height-fix
          :data="tableData"
          height="100%"
        >
          <el-table-column prop="key" label="流程步骤标识符" />

          <el-table-column prop="fName" label="流程步骤名称" />

          <el-table-column class-name="table-oper-col" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ConfirmButton from '@components/ConfirmButton'
import Modify from './Modify'

export default {
  components: {
    ConfirmButton,
    Modify
  },
  data: function() {
    return {
      loading: false,
      showDisabled: 'F',
      searchText: '',

      pageRecordTotal: 0,
      tableData: [],
      currentEditNode: null,
      currentEditItem: null,
      listData: []
    }
  },
  computed: {
    userInfo: function() {
      return this.$store.state.userInfo
    },
    userOrgId: function() {
      return this.userInfo.org.fOrganizationID
    }
  },
  mounted: function() {},
  methods: {
    handleTreeData: function(data) {
      // console.log(data, "data");
      const fNamearr = []
      this.listData = data
      data.forEach((item) => {
        fNamearr.push({ fName: item.fName })
      })
      return {
        fName: '流程列表',
        entrys: fNamearr
      }
    },

    handleNodeClick: function(row) {
      // console.log(row, "row");
      this.currentEditNode = row
      // this.refresh();
      this.listData.forEach((v) => {
        if (v.fName == row.fName) {
          this.tableData = v.entrys
        }
      })
    },

    handleNodeModify: function(row, parent) {

    },

    handleNodeDelete: function(row) {
      this.postDataTree(3, row)
    },

    _modify: function(row) {
      const h = this.$createElement
      this.$formDlg({
        title: `流程步骤对应审批人`,
        width: '50%',
        formTpl: <Modify form={row}></Modify>,
        formSubmit: (formData) => this.postData(isNew ? 1 : 2, formData),
        readonly: true
      })
    },

    postData: function(modifyType, data) {
      return this.$httpPost('BasicData/Item/ItemModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          itemInfo: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },

    postDataTree: function(modifyType, data) {
      return this.$httpPost('BasicData/Item/ItemGroupModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          itemGroupInfo: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refreshTree()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },

    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    dateTimeFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    refresh: function() {
      if (!this.currentEditNode) return

      if (!this.currentEditNode.key) {
        this.tableData = []
        this.pageRecordTotal = 0
        return
      }

      this.loading = true
      this.$httpPost('SystemApplication/ProcedureStep/ProcedureForUserEntry', {
        // isDeleted: this.showDisabled,
        key: this.currentEditNode.key
      })
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },

    refreshTree: function() {
      this.$refs.tree.refresh()
    }
  }
}
</script>
